

































































































































































import Vue from "vue";
import GoBackHeader from "@/components/shared/GoBackHeader.vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import {
  ACTIVATE_PUBLISHED_JOB,
  JOB_GENERATION_FROM_PROMPT,
  JOB_GENERATION_MATCHING_CANDIDATES,
  JOB_GENERATION_PROMPT_RESPONSE,
  JOB_GENERATION_REJECTED_MATCHING_CANDIDATES,
  POST_JOB,
  JOB_SHORT_URL,
  JOB_GENERATION_ACCEPTED_MATCHING_CANDIDATES,
  CANDIDATE_DATA,
  RECOMMEND_JOB_PROFILES
} from "@/store/modules/recruiter/constants";
import AppOverlayLoader from "@/components/shared/AppOverlayLoader.vue";
import { get_search_candidates } from "@/store/apis/recruiter";
import { ROOT_ERROR, ROOT_NOTIFICATION } from "@/store/modules/root/constants";
import { SEND_EMAIL } from "@/store/modules/common/constants";
import { EmailTypes } from "@/interfaces/app.interface";
import { GET_USER_DETAILS } from "@/store/modules/auth/constants";
import { VIEW_JOB_STATE } from "@/store/modules/common/constants";
import { ViewJobState } from "@/store/modules/common/interfaces";
import router from "@/router";
export default Vue.extend({
  name: "PostAiGenerativeJob",
  data() {
    return {
      is_microphone_active: false,
      prompt: "",
      transcription: "",
      recognition: null as typeof window.webkitSpeechRecognition | null, // Speech recognition object
      generation_loading: false,
      generation_loading_msg: "",
      generated_voices: new Set<string>(),
      screening_question: false
    };
  },
  mounted() {
    this.init_speak_recognition();
  },
  components: {
    GoBackHeader,
    AppOverlayLoader
  },
  computed: {
    ...mapGetters("recruiter", {
      job_generation_prompt_resp: JOB_GENERATION_PROMPT_RESPONSE
    }),
    ...mapGetters("auth", {
      get_user_details: GET_USER_DETAILS
    })
  },
  methods: {
    ...mapMutations({
      root_error: ROOT_ERROR,
      root_notification: ROOT_NOTIFICATION
    }),
    ...mapMutations("recruiter", {
      set_ai_generated_job_post_prompt: JOB_GENERATION_FROM_PROMPT,
      set_ai_generated_prompt_resp: JOB_GENERATION_PROMPT_RESPONSE,
      set_ai_generated_matching_candidates: JOB_GENERATION_MATCHING_CANDIDATES,
      set_rejected_candidates: JOB_GENERATION_REJECTED_MATCHING_CANDIDATES,
      set_shortlisted_candidates: JOB_GENERATION_ACCEPTED_MATCHING_CANDIDATES,
      set_candidate_data: JOB_GENERATION_MATCHING_CANDIDATES,
      set_all_candidates_data: CANDIDATE_DATA
    }),
    ...mapMutations("recruiter", {
      set_recommend_job_profiles: RECOMMEND_JOB_PROFILES
    }),
    ...mapMutations("common", {
      set_view_job_state: VIEW_JOB_STATE
    }),
    ...mapActions("recruiter", {
      generate_job_from_prompt: JOB_GENERATION_FROM_PROMPT,
      post_job: POST_JOB,
      activate_published_job: ACTIVATE_PUBLISHED_JOB,
      get_job_short_url: JOB_SHORT_URL
    }),
    ...mapActions("common", {
      send_email: SEND_EMAIL
    }),
    init_speak_recognition() {
      const speech_recognition = window.webkitSpeechRecognition;
      this.recognition = new speech_recognition(); // Create a new speech recognition object
      this.recognition.interimResults = true; // Set interim results to true so that we can get the result before the user stops speaking
      this.recognition.continuous = true; // Set continuous to true so that we can get the result continuously
      this.recognition.onresult = (event: any) => {
        const results = Array.from(
          // eslint-disable-next-line no-undef
          event.results as SpeechRecognitionResult[]
        );
        let last_final_result = null;
        for (let i = results.length - 1; i >= 0; i--) {
          // Iterate in reverse
          if (results[i].isFinal) {
            last_final_result = results[i];
            break; // Found it, no need to continue
          }
        }

        if (last_final_result) {
          const transcript = last_final_result[0].transcript;
          if (transcript) {
            const formatted = transcript.trim().toLowerCase();
            if (!this.generated_voices.has(formatted)) {
              this.prompt += " " + formatted;
              this.generated_voices.add(formatted);
            }
          }
        }
      };
    },
    speak_config() {
      this.is_microphone_active = !this.is_microphone_active;
      if (this.is_microphone_active) {
        this.recognition.start();
      } else {
        this.recognition.stop();
      }
    },
    repeat_prompt() {
      const videoElement = this.$refs.videoElement as HTMLVideoElement;
      if (videoElement) {
        videoElement.currentTime = 0;
        videoElement.play();
        videoElement.onended = () => {
          if (!this.is_microphone_active) this.speak_config();
        };
      }
    },
    async generate_prompt() {
      try {
        this.generation_loading = true;
        this.generation_loading_msg = "Generating Job...";
        await this.submit_form();
      } catch (error: any) {
        this.root_error(error.message || "Internal server error");
      } finally {
        this.generation_loading = false;
        this.generation_loading_msg = "";
      }
    },
    async submit_form() {
      const obj = {
        prompt: this.prompt,
        post_type: "prompt"
      };

      const response = await this.post_job(obj);
      if (response) {
        this.set_recommend_job_profiles(response.recommend_job_profiles);
        this.set_view_job_state(ViewJobState.FILE_JOB_POST);
        await router.push(`/job/${response.standardized_data.jid}`);

        this.root_notification(this.$t("success-messages.job-post-success"));
      } else {
        this.root_error(this.$t("errors.job-post-failed"));
      }
    },
    async fetch_matching_candidates(jid: number) {
      try {
        const search_candidates = await get_search_candidates({
          job_ids: [jid]
        });
        const results = search_candidates?.data?.data?.results;
        if (results.length <= 0) {
          throw new Error("No matching candidates found");
        } else return results;
      } catch (e) {
        this.generation_loading = false;
        this.generation_loading_msg = "";
        return null;
      }
    },
    /**
     * Generates a short URL for the job using its ID and a base job URL.
     * The resulting URL is stored in the `this.url` property.
     */
    async generate_short_url(jobId: number) {
      const obj = {
        job_id: jobId,
        job_url: `https://${window.location.hostname}/public/job`
      };
      const response = await this.get_job_short_url(obj);
      return response.url ? response.url : undefined;
    },
    async proceed_to_create_job(is_screening_question: boolean) {
      if (is_screening_question)
        this.$router.push({
          name: "recruiter-screening_question"
        });
      else {
        try {
          this.generation_loading = true;
          this.generation_loading_msg = "Posting Job...";
          const job_post_payload = this.job_generation_prompt_resp;
          const job_post_form_data = new FormData();
          Object.entries(job_post_payload).forEach(([key, value]) => {
            job_post_form_data.append(key, value as string);
          });
          job_post_form_data.append("post_type", "text");

          const job_posted = await this.post_job(job_post_form_data);
          if (!job_posted) throw new Error("Failed to post job");
          this.set_ai_generated_prompt_resp({
            ...this.job_generation_prompt_resp,
            job_id: job_posted?.standardized_data?.jid
          });
          const jid = job_posted?.standardized_data?.jid;
          if (!jid) throw new Error("Failed to post job");

          const job_published = await this.activate_published_job(jid);
          if (!job_published) throw new Error("Failed to post job");

          // this.generation_loading_msg = "Fetching matching candidates...";
          // const matching_candidates = await this.fetch_matching_candidates(jid);
          // if (!matching_candidates)
          //   throw new Error("No matching candidates found");

          // this.set_ai_generated_matching_candidates(matching_candidates);
          // this.set_all_candidates_data(matching_candidates);
          this.root_notification("Job posted successfully");

          // here email send
          const url = await this.generate_short_url(jid);

          await this.send_email({
            user_ids: [this.get_user_details.id],
            type: EmailTypes.TWO_POINT_INTERNAL_JOB_POST,
            job: {
              jid: jid,
              title: job_posted?.standardized_data?.job_title,
              description: job_post_payload.job_description,
              link: url ?? `/recruiter/jobs/${jid}`
            }
          });

          // TODO: Navigate to next page
          // await this.$router.push({
          //   name: "swipe-candidate-job-posting"
          // });

          await this.$router.push({
            name: "recruiter-job-listing"
          });
        } catch (error: any) {
          this.root_error(error.message || "Internal server error");
        } finally {
          this.generation_loading = false;
          this.generation_loading_msg = "";
        }
      }
      this.screening_question = false;
    }
  },
  beforeDestroy() {
    if (this.recognition) {
      if (this.is_microphone_active) this.speak_config();
      this.recognition.stop();
    }
  }
});
